import * as React from "react";

import { L10nContext } from "client/context/branding-context";
import { L10n } from "client/utils/branding";

export function useBranding(): L10n {
  const ctx = React.useContext(L10nContext);
  if (ctx === undefined) {
    throw new Error(`useBranding must be used within a L10nContext provider`);
  }
  return ctx;
}
